




import { BaseElement } from '@/api/com/MetaPattern/MDA/MD/Base/BaseElement';
import { BEServiceAction } from '@/api/com/MetaPattern/MDA/MD/EntityModel/BEServiceAction';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import PGRowElementSelect from './PGRowElementSelect.vue';

@Component({
  components: {
    PGRowElementSelect
  }
})
/** 服务操作相同组件下的外部服务 */
export default class PGRowBusinessLogicValue extends Vue {
  @Prop() private value!: string;
  @Prop() private isEditable!: boolean;
  @Prop() private elementDesignId!: string; // 服务操作的设计期ID

  valueChanged(newValue: string, newElement: BaseElement): void {
    this.$emit('valueChanged', newValue, newElement);
  }

  get options() {
    const serviceAction = this.$store.state.ModuleMD.elements.find((item: BaseElement) => item.designId === this.elementDesignId) as BEServiceAction;
    return serviceAction.service.component.businessLogics;
  }
}
